import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { LIFormFieldValues } from '@/domain/job-application/types';

import {
  useDisableAdditionalComments,
  useIsEmailFieldPrefilled,
  useIsPhoneFieldPrefilled,
  useShowAdditionalDocs,
} from '../../contexts';
import {
  CommentsField,
  CountryCodeField,
  CvDocumentUploadField,
  EmailField,
  OtherDocumentsUploadField,
  PhoneField,
} from '../form-fields';
import { UserProfileCompletion } from '../user-profile-completion';

import * as S from '../../job-application.common.styles';

type Props = {
  control: Control<LIFormFieldValues>;
  updateUploadDocsHandler: (value: string, field: 'cvDoc' | 'otherDocs') => void;
};

export const LoggedInApplyForm: React.VFC<Props> = ({ control, updateUploadDocsHandler }) => {
  const { isEmailPrefilled } = useIsEmailFieldPrefilled();
  const { isPhonePrefilled } = useIsPhoneFieldPrefilled();
  const isAdditionalCommentsDisabled = useDisableAdditionalComments();
  const showAdditionalDocs = useShowAdditionalDocs();

  return (
    <>
      <S.Section>
        <UserProfileCompletion />
      </S.Section>
      <S.Section>
        <S.SectionHeadline size="large">
          <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_CONTACT_DETAILS_HEADLINE" />
        </S.SectionHeadline>
        <EmailField control={control} isPrefilled={isEmailPrefilled} />
        <S.LIPhoneWrapper>
          <S.FirstFieldWrapper>
            <CountryCodeField control={control} />
          </S.FirstFieldWrapper>
          <S.LastFieldWrapper>
            <PhoneField control={control} isPrefilled={isPhonePrefilled} isOptionalLabelCopy />
          </S.LastFieldWrapper>
        </S.LIPhoneWrapper>
      </S.Section>
      <CvDocumentUploadField control={control} updateValue={updateUploadDocsHandler} />
      {showAdditionalDocs ? (
        <OtherDocumentsUploadField control={control} updateValue={updateUploadDocsHandler} />
      ) : null}
      {isAdditionalCommentsDisabled ? null : (
        <S.Section>
          <S.CommentsSectionHeadline size="large">
            <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_ADDITIONAL_COMMENTS_HEADLINE" />
          </S.CommentsSectionHeadline>
          <S.CommentsBodyCopy size="medium" lineHeight="dense">
            <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_ADDITIONAL_COMMENTS_BODY" />
          </S.CommentsBodyCopy>
          <CommentsField control={control} />
        </S.Section>
      )}
    </>
  );
};
